import React from 'react';
import { useImageUploader } from './hooks/useImageUploader';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  LinearProgress
} from '@material-ui/core';
import CropIcon from '@material-ui/icons/Crop';
import DeleteIcon from '@material-ui/icons/Delete';
import { MediaTypeEnum } from '../../../../../../../../../../api';
import { StyledDropzone } from '../../../../../../../../../../components/StyledDropZone/StyledDropZone';
import Button from '@material-ui/core/Button';
import { CropImage } from './CropImage/CropImage';

interface Props {
  open: boolean;
  onClose: () => void;
}

export const ImageUploader: React.FC<Props> = ({ open, onClose }: Props) => {
  const vm = useImageUploader(onClose);

  return (
    <Dialog open={open} fullWidth maxWidth="lg" onClose={onClose} disableBackdropClick>
      <DialogTitle>Upload images</DialogTitle>
      <DialogContent dividers>
        {!!vm.images.length && (
          <div>
            <CropImage
              open={vm.cropDialogOpen}
              onClose={vm.handleCropDialogClose}
              handleSaveCrop={vm.handleSaveCrop}
              image={vm.cropImage}
            />
            <div className="w-fit ml-auto">
              <Button size="small" color="primary" onClick={vm.triggerStyledDropzone} disabled={vm.loading}>
                add more
              </Button>
            </div>
            <div className="flex overflow-y-auto flex-wrap">
              {vm.images.map((image, index) => (
                <div key={index} className="shadow rounded-sm m-2 flex flex-col">
                  <div className="w-72 h-72 flex justify-center items-center">
                    <img src={image.croppedObjectUrl} className="max-w-full max-h-full p-1" />
                  </div>
                  <Divider />
                  <div className="h-10 p-2 flex justify-between">
                    <IconButton
                      size="small"
                      color="primary"
                      onClick={() => vm.handleCropButtonClick(index)}
                      disabled={vm.loading}
                    >
                      <CropIcon />
                    </IconButton>

                    <IconButton
                      size="small"
                      color="secondary"
                      onClick={() => vm.handleFileDelete(index)}
                      disabled={vm.loading}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
        <div className={vm.images.length ? 'hidden' : ''}>
          <StyledDropzone
            // @ts-ignore
            ref={vm.styledDropzoneRef}
            onSelectFile={vm.handleFilesSelect}
            mediaType={MediaTypeEnum.IMAGE}
            multiple={true}
          />
        </div>
      </DialogContent>
      <div className="h-1">{vm.loading && <LinearProgress />}</div>
      <DialogActions>
        <Button size="small" variant="text" color="secondary" onClick={onClose}>
          cancel
        </Button>
        <Button
          size="small"
          variant="contained"
          color="primary"
          className="mr-2"
          onClick={vm.handleSave}
          disabled={!vm.images.length || vm.loading}
        >
          save
        </Button>
      </DialogActions>
    </Dialog>
  );
};
